function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.22037 3.1738H7.55958L5.41317 0.715527C5.22972 0.513729 4.91785 0.477038 4.69771 0.660491C4.49591 0.843944 4.45922 1.15581 4.64267 1.37596L6.22037 3.1738Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7333 2.4215C10.9351 2.2197 10.9351 1.90783 10.7333 1.70604C10.5315 1.50424 10.2197 1.50424 10.0179 1.70604L8.5686 3.15532H9.98119L10.7333 2.4215Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5124 3.72412H7.99985H1.48726C0.863522 3.72412 0.349854 4.23779 0.349854 4.86153V13.0252C0.349854 13.6489 0.863522 14.1626 1.48726 14.1626H3.24841H12.7513H14.5124C15.1362 14.1626 15.6499 13.6489 15.6499 13.0252V4.86153C15.6499 4.23779 15.1362 3.72412 14.5124 3.72412ZM11.1552 11.7777C11.1552 12.218 10.8067 12.5666 10.3664 12.5666H2.82647C2.38618 12.5666 2.03762 12.218 2.03762 11.7777V6.12736C2.03762 5.68707 2.38618 5.33851 2.82647 5.33851H10.3664C10.8067 5.33851 11.1552 5.68707 11.1552 6.12736V11.7777ZM14.4024 10.0166C14.4024 10.1083 14.329 10.1817 14.2373 10.1817H12.5862C12.4945 10.1817 12.4211 10.1083 12.4211 10.0166V8.76908C12.4211 8.67736 12.4945 8.60398 12.5862 8.60398H14.2373C14.329 8.60398 14.4024 8.67736 14.4024 8.76908V10.0166ZM14.4024 7.37484C14.4024 7.46657 14.329 7.53995 14.2373 7.53995H12.5862C12.4945 7.53995 12.4211 7.46657 12.4211 7.37484V6.12736C12.4211 6.03563 12.4945 5.96225 12.5862 5.96225H14.2373C14.329 5.96225 14.4024 6.03563 14.4024 6.12736V7.37484Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.48724 15.1715C1.48724 15.5017 1.74408 15.7586 2.07429 15.7586H2.66134C2.99156 15.7586 3.24839 15.5017 3.24839 15.1715V14.7129H1.48724V15.1715Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7513 15.1715C12.7513 15.5017 13.0081 15.7586 13.3383 15.7586H13.9254C14.2556 15.7586 14.5124 15.5017 14.5124 15.1715V14.7129H12.7513V15.1715Z"
});

var SvgTvIcon = function SvgTvIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTvIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tv-icon.41b1ba70.svg";
export { ForwardRef as ReactComponent };